
import { ResultData } from "@nt-portal/common-sdk";

import { DbInuseResult, TCMCategory, TCMCategoryService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { ValidateResult } from "@nt-portal/common-sdk";


export interface TCMCategoryOptions extends ControllerOptions<TCMCategory> {
    hide?: boolean;
}

export const initTCMCategory = (obj: Partial<TCMCategory>) => {
    let item: TCMCategory = {
        name: "",
        createdBy: ""
    }
    return item;
}

export class ClientTCMCategoryService extends BaseClientService implements DataController<TCMCategory> {

    private _service: TCMCategoryService;


    constructor() {
        super();
        this._service = new TCMCategoryService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }



    public async get(options: TCMCategoryOptions): Promise<ResultData<TCMCategory>> {
        return await this._service.get(this.buildFetchParams(options), this.token,);
    }

    public async getLookup(options: TCMCategoryOptions): Promise<ResultData<TCMCategory>> {

        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;

    }

    public async validate(name: string, id?: string): Promise<ValidateResult> {

        return await this._service.validateName(name, this.token, id)

    }

    public async getById(options: TCMCategoryOptions): Promise<TCMCategory | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMCategoryOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMCategoryOptions): Promise<TCMCategory | TCMCategory[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMCategoryOptions): Promise<TCMCategory | TCMCategory[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async inUse(options: TCMCategoryOptions): Promise<DbInuseResult[]> {
        if (options.id) {
            return await this._service.inUse(options.id, this.token);
        } else {
            throw new Error("ID is required for inUse check");
        }
    }

    public async import(options: TCMCategoryOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMCategoryOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

}